import { render, staticRenderFns } from "./CultswitchList.vue?vue&type=template&id=438ee412"
import script from "./CultswitchList.vue?vue&type=script&lang=js"
export * from "./CultswitchList.vue?vue&type=script&lang=js"
import style0 from "./CultswitchList.vue?vue&type=style&index=0&id=438ee412&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports